"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDisplay = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var react_1 = require("react");
var hooks_1 = require("../hooks/hooks");
var styles_1 = require("../styles");
var base_1 = require("./base");
var moment_1 = __importDefault(require("moment"));
var context_1 = require("../context/context");
var utils_1 = require("../utils");
var Expiry = function (_a) {
    var _b;
    var deadline = _a.deadline;
    var t = (_b = (0, context_1.useTwapContext)()) === null || _b === void 0 ? void 0 : _b.translations;
    var res = (0, react_1.useMemo)(function () { return (0, moment_1.default)(deadline).format("ll HH:mm"); }, [deadline]);
    return ((0, jsx_runtime_1.jsx)(DetailRow, __assign({ title: t.expiration, tooltip: t.confirmationDeadlineTooltip }, { children: res })));
};
var ChunkSize = function (_a) {
    var srcChunkAmount = _a.srcChunkAmount, srcToken = _a.srcToken;
    var translations = (0, context_1.useTwapContext)().translations;
    var _srcChunkAmount = (0, hooks_1.useFormatNumberV2)({ value: srcChunkAmount, decimalScale: 3 });
    return ((0, jsx_runtime_1.jsx)(DetailRow, __assign({ title: translations.individualTradeSize, tooltip: translations.confirmationTradeSizeTooltip }, { children: "".concat(_srcChunkAmount, " ").concat(srcToken === null || srcToken === void 0 ? void 0 : srcToken.symbol) })));
};
var MinDestAmount = function (_a) {
    var dstToken = _a.dstToken, isMarketOrder = _a.isMarketOrder, dstMinAmountOut = _a.dstMinAmountOut, totalChunks = _a.totalChunks;
    var translations = (0, context_1.useTwapContext)().translations;
    var formattedValue = (0, hooks_1.useFormatNumberV2)({ value: dstMinAmountOut });
    if (isMarketOrder)
        return null;
    return ((0, jsx_runtime_1.jsx)(DetailRow, __assign({ title: totalChunks === 1 ? "Min. received" : translations.minReceivedPerTrade, tooltip: translations.confirmationMinDstAmountTootipLimit }, { children: "".concat(formattedValue, " ").concat(dstToken === null || dstToken === void 0 ? void 0 : dstToken.symbol) })));
};
var ChunksAmount = function (_a) {
    var chunks = _a.chunks;
    var t = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsx)(DetailRow, __assign({ title: t.numberOfTrades, tooltip: t.confirmationTotalTradesTooltip }, { children: chunks })));
};
var Recipient = function () {
    var _a = (0, context_1.useTwapContext)(), t = _a.translations, account = _a.account;
    var explorerUrl = (0, hooks_1.useExplorerUrl)();
    var makerAddress = (0, hooks_1.usemElipsisAddress)(account);
    return ((0, jsx_runtime_1.jsx)(DetailRow, __assign({ title: t.recipient }, { children: !explorerUrl ? (makerAddress) : ((0, jsx_runtime_1.jsx)("a", __assign({ href: "".concat(explorerUrl, "/address/").concat(account), target: "_blank" }, { children: makerAddress }))) })));
};
var TradeInterval = function (_a) {
    var _b;
    var fillDelayMillis = _a.fillDelayMillis;
    var t = (_b = (0, context_1.useTwapContext)()) === null || _b === void 0 ? void 0 : _b.translations;
    var text = (0, react_1.useMemo)(function () { return (0, utils_1.fillDelayText)(fillDelayMillis, t); }, [fillDelayMillis, t]);
    return ((0, jsx_runtime_1.jsx)(DetailRow, __assign({ title: t.tradeInterval, tooltip: t.confirmationtradeIntervalTooltip }, { children: text })));
};
var StyledDetails = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({});
var DetailRow = function (_a) {
    var title = _a.title, tooltip = _a.tooltip, children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b, startLogo = _a.startLogo;
    return ((0, jsx_runtime_1.jsxs)(StyledDetailRow, __assign({ className: "".concat(className, " twap-order-display-details-row") }, { children: [(0, jsx_runtime_1.jsxs)(StyledLabel, { children: [(0, jsx_runtime_1.jsx)(base_1.Label.Text, { text: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [startLogo, " ", title] }) }), tooltip && (0, jsx_runtime_1.jsx)(base_1.Label.Info, { text: tooltip })] }), (0, jsx_runtime_1.jsx)(StyledDetailRowChildren, __assign({ className: "twap-order-display-details-row-right" }, { children: children }))] })));
};
var TxHash = function (_a) {
    var txHash = _a.txHash;
    var t = (0, context_1.useTwapContext)().translations;
    var txHashAddress = (0, hooks_1.usemElipsisAddress)(txHash);
    var explorerUrl = (0, hooks_1.useExplorerUrl)();
    if (!txHash)
        return null;
    return ((0, jsx_runtime_1.jsx)(DetailRow, __assign({ title: t.txHash }, { children: !explorerUrl ? (txHashAddress) : ((0, jsx_runtime_1.jsx)("a", __assign({ href: "".concat(explorerUrl, "/tx/").concat(txHash), target: "_blank" }, { children: txHashAddress }))) })));
};
var Details = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, children = _a.children, onClick = _a.onClick;
    return ((0, jsx_runtime_1.jsx)(StyledDetails, __assign({ onClick: onClick, className: "twap-order-display-details ".concat(className) }, { children: children })));
};
function OrderDisplay(_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b;
    return (0, jsx_runtime_1.jsx)(Container, __assign({ className: "".concat(className, " twap-order-display") }, { children: children }));
}
exports.OrderDisplay = OrderDisplay;
var TokenDisplay = function (_a) {
    var amount = _a.amount, token = _a.token, usd = _a.usd, title = _a.title, content = _a.content;
    var _usd = (0, hooks_1.useFormatNumberV2)({ value: usd, decimalScale: 2 });
    var _amount = (0, hooks_1.useFormatNumberV2)({ value: amount });
    return ((0, jsx_runtime_1.jsxs)(StyledTokenDisplay, __assign({ className: "twap-order-display-token-usd" }, { children: [(0, jsx_runtime_1.jsxs)(StyledTokenRight, __assign({ className: "twap-order-display-token-right" }, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledText, __assign({ className: "twap-order-display-token-title" }, { children: title })), (0, jsx_runtime_1.jsxs)(styles_1.StyledText, __assign({ className: "twap-order-display-token-amount" }, { children: [amount ? _amount : "", " ", token === null || token === void 0 ? void 0 : token.symbol] })), usd && (0, jsx_runtime_1.jsx)(USD, { usd: _usd }), content] })), (0, jsx_runtime_1.jsx)(base_1.TokenLogo, { className: "twap-order-display-token-usd-logo", logo: token === null || token === void 0 ? void 0 : token.logoUrl })] })));
};
var USD = function (_a) {
    var usd = _a.usd, _b = _a.className, className = _b === void 0 ? "" : _b;
    var Components = (0, context_1.useTwapContext)().Components;
    if (Components === null || Components === void 0 ? void 0 : Components.USD) {
        return (0, jsx_runtime_1.jsx)(Components.USD, { value: usd });
    }
    return (0, jsx_runtime_1.jsxs)(StyledSmallText, __assign({ className: "twap-order-display-token-usd ".concat(className) }, { children: ["$", usd] }));
};
var SrcToken = function (_a) {
    var amount = _a.amount, token = _a.token, usd = _a.usd;
    var isLimitPanel = (0, context_1.useTwapContext)().isLimitPanel;
    return (0, jsx_runtime_1.jsx)(TokenDisplay, { amount: amount, token: token, usd: usd, title: isLimitPanel ? "From" : "Allocate" });
};
var DstToken = function (_a) {
    var amount = _a.amount, token = _a.token, usd = _a.usd, isMarketOrder = _a.isMarketOrder, fillDelayMillis = _a.fillDelayMillis, chunks = _a.chunks;
    var t = (0, context_1.useTwapContext)().translations;
    var content = (0, react_1.useMemo)(function () {
        if (!isMarketOrder)
            return null;
        return ((0, jsx_runtime_1.jsxs)(StyledSmallText, __assign({ className: "twap-small-text" }, { children: ["Every ", (0, utils_1.fillDelayText)(fillDelayMillis, t).toLowerCase(), " Over ", chunks, " Orders"] })));
    }, [chunks, isMarketOrder, fillDelayMillis, t]);
    return (0, jsx_runtime_1.jsx)(TokenDisplay, { content: content, amount: !isMarketOrder ? amount : "", token: token, usd: !isMarketOrder ? usd : "", title: !isMarketOrder ? "To" : "Buy" });
};
var StyledSmallText = (0, styled_components_1.styled)(styles_1.StyledText)({
    fontSize: 14,
});
var TokensContainer = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, children = _a.children;
    return (0, jsx_runtime_1.jsx)(StyledTokens, __assign({ className: "twap-order-display-tokens ".concat(className) }, { children: children }));
};
OrderDisplay.DetailsContainer = Details;
OrderDisplay.Tokens = TokensContainer;
OrderDisplay.SrcToken = SrcToken;
OrderDisplay.DstToken = DstToken;
OrderDisplay.Expiry = Expiry;
OrderDisplay.ChunkSize = ChunkSize;
OrderDisplay.MinDestAmount = MinDestAmount;
OrderDisplay.ChunksAmount = ChunksAmount;
OrderDisplay.Recipient = Recipient;
OrderDisplay.TradeInterval = TradeInterval;
OrderDisplay.DetailRow = DetailRow;
OrderDisplay.TxHash = TxHash;
var StyledLabel = (0, styled_components_1.styled)(base_1.Label)({
    ".twap-label-text": {
        fontSize: 14,
    },
});
var StyledTokens = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    gap: 24,
});
var Container = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    gap: 0,
    ".twap-separator": {
        margin: "20px 0px",
    },
    ".twap-order-display-details": {
        gap: 8,
    },
});
var StyledDetailRow = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({
    flexWrap: "wrap",
    justifyContent: "space-between",
});
var StyledDetailRowChildren = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({
    width: "auto",
    justifyContent: "flex-end",
    marginLeft: "auto",
    fontSize: 14,
    "*": {
        fontSize: "inherit",
    },
    a: {
        color: "inherit",
        textDecoration: "unset",
        "&:hover": {
            textDecoration: "underline",
        },
    },
});
var StyledTokenRight = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    width: "auto",
    flex: 1,
    justifyContent: "space-between",
    gap: 4,
});
var StyledTokenDisplay = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({
    alignItems: "center",
    gap: 4,
    ".twap-order-modal-token-title": {
        opacity: 0.7,
        fontSize: 14,
    },
    ".twap-order-modal-token-amount": {
        fontSize: 29,
        lineHeight: "30px",
        flex: 1,
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    ".twap-token-logo": {
        width: 36,
        height: 36,
    },
    ".twap-order-modal-token-usd": {
        opacity: 0.7,
        fontSize: 14,
    },
});
